<script setup lang="ts">
const props = defineProps({
  car: {
    type: Object,
    default: () => ({}),
  }
})

const { t } = useI18n({
  useScope: 'global'
})

</script>

<template>
  <div class="item__bottom">
    <div class="actions" />
    <NuxtLinkLocale
      :to="`/guest/cars/${car.vinCode}`"
    >
      <FormKit
        type="button"
      >
        {{ t('cars.labels.details') }}
      </FormKit>
    </NuxtLinkLocale>
  </div>
</template>



<style scoped>
.item__bottom {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 15px 8px;
  justify-content: space-between;
  flex-wrap: wrap;

  .actions {
    display: flex;
    align-items: center;
    white-space: nowrap;
    flex-wrap: wrap;
  }
}
</style>
